(function () {
  var desktopQuery = window.matchMedia('(min-width: 769px) and (hover: hover) and (pointer: fine)');
  var closeDelay = 180;

  function initHeaderHoverMenus(root) {
    if (!desktopQuery.matches) return;

    (root || document).querySelectorAll('.site-header .site-nav--has-dropdown').forEach(function (item) {
      if (item.dataset.mxHoverReady === 'true') return;
      item.dataset.mxHoverReady = 'true';

      var trigger = item.querySelector(':scope > .site-nav__link--has-dropdown');
      var closeTimer;

      function openMenu() {
        window.clearTimeout(closeTimer);
        document.querySelectorAll('.site-header .site-nav--has-dropdown.mx-nav-hover-open').forEach(function (openItem) {
          if (openItem !== item) {
            openItem.classList.remove('mx-nav-hover-open');
            var openTrigger = openItem.querySelector(':scope > .site-nav__link--has-dropdown');
            if (openTrigger) openTrigger.setAttribute('aria-expanded', 'false');
          }
        });

        item.classList.add('mx-nav-hover-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
      }

      function scheduleClose() {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(function () {
          item.classList.remove('mx-nav-hover-open');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        }, closeDelay);
      }

      item.addEventListener('pointerenter', openMenu);
      item.addEventListener('pointerleave', scheduleClose);
      item.addEventListener('focusin', openMenu);
      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) scheduleClose();
      });
    });
  }

  function closeAllMenus() {
    document.querySelectorAll('.site-header .site-nav--has-dropdown.mx-nav-hover-open').forEach(function (item) {
      item.classList.remove('mx-nav-hover-open');
      var trigger = item.querySelector(':scope > .site-nav__link--has-dropdown');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeaderHoverMenus(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initHeaderHoverMenus(event.target);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAllMenus();
  });

  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener('change', function (event) {
      if (event.matches) initHeaderHoverMenus(document);
      else closeAllMenus();
    });
  }
})();
